export const baseURL = 'https://backend.quickfluence.com/api/v1';
// export const baseURL = 'http://192.168.29.9:8888/quick-fluence-backend/api/v1';

